import ForecastTooltip from '../tooltips/ForecastTooltip';
import React, {ReactElement} from 'react';
import styled from 'styled-components';
import {Icon} from '@forecast-it/design-system';

const TimeregActionButtonStyle = styled.button`
	border: none;
	background: none;
	padding: 0;
`;

interface TimeregActionButtonProps {
	disabled?: boolean;
	onClick: (event: React.MouseEvent<HTMLElement>) => void;
	text: string;
	icon: string;
	'data-cy': string;
}
const TimeregActionButton = ({
	disabled = false,
	onClick,
	text,
	icon,
	'data-cy': dataCy,
}: TimeregActionButtonProps): ReactElement | null => {
	return (
		<TimeregActionButtonStyle
			onClick={e => {
				e.stopPropagation();
				onClick(e);
			}}
			disabled={disabled}
			aria-label={text}
			data-cy={dataCy}
		>
			<ForecastTooltip content={text} maxWidth={250}>
				<Icon icon={icon} color={disabled ? 'disabled' : 'default'} />
			</ForecastTooltip>
		</TimeregActionButtonStyle>
	);
};

export default TimeregActionButton;
